import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import Raven from 'raven-js';
import { useMemo } from 'react';
import { RECURRING } from 'self-service-api/constants/ChargeTypes';
import { ADD_ON_CARD } from '../../constants/tracking/TrackingSources';
import { useMonthlyCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { AddOnCardPricingFallback } from './AddOnCardFallbacks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnCardPricing = ({
  productConfigurations,
  skuId,
  term
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const isRecurring = product && product.chargeType === RECURRING;
  const {
    monthlyCalculatedPrice
  } = useMonthlyCalculatedPrice({
    apiName: product.apiName,
    queryParamTerm: term
  });
  const singleUnitPrice = useMemo(() => {
    if (monthlyCalculatedPrice && isRecurring) {
      var _productConfiguration;
      const selectedQuantity = ((_productConfiguration = productConfigurations.find(config => config.skuId === skuId)) === null || _productConfiguration === void 0 ? void 0 : _productConfiguration.quantity) || 1;
      return monthlyCalculatedPrice * selectedQuantity;
    }
    if (!isRecurring) {
      Raven.captureException(new Error('AddOnCardPricing: Attempting to show one-time fee pricing for product with pricing API enabled. One-time fees may need to be handled differently'));
    }
  }, [isRecurring, monthlyCalculatedPrice, productConfigurations, skuId]);
  if (!singleUnitPrice) {
    return /*#__PURE__*/_jsx(AddOnCardPricingFallback, {});
  }
  return /*#__PURE__*/_jsxs(Text, {
    as: "h6",
    "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}-price`,
    children: [/*#__PURE__*/_jsx(PriceDisplay, {
      price: singleUnitPrice,
      currencyCode: currencyCode
    }), isRecurring ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.priceDisplay.perMonth"
    }) : /*#__PURE__*/_jsx(View, {
      marginBlockStart: '100',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.notes.oneTimeFeeParentheses"
      })
    })]
  });
};